import { render, staticRenderFns } from "./data-table-positions.vue?vue&type=template&id=20964c9a&scoped=true&"
import script from "./data-table-positions.vue?vue&type=script&lang=js&"
export * from "./data-table-positions.vue?vue&type=script&lang=js&"
import style0 from "./data-table-positions.vue?vue&type=style&index=0&id=20964c9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20964c9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20964c9a')) {
      api.createRecord('20964c9a', component.options)
    } else {
      api.reload('20964c9a', component.options)
    }
    module.hot.accept("./data-table-positions.vue?vue&type=template&id=20964c9a&scoped=true&", function () {
      api.rerender('20964c9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/positions/data-table/data-table-positions.vue"
export default component.exports